import React from "react";
import { useTranslation } from "react-i18next";

const UserTableHeader = () => {
  const { t } = useTranslation();

  return (
    <thead>
      <tr role="row">
        <th className="sorting">{t("Nom")}</th>
        <th className="sorting">{t("Email")}</th>
        <th className="sorting">{t("Rôle")}</th>
        <th className="sorting">{t("Statut")}</th>
        <th className="sorting">{t("Actions")}</th>
      </tr>
    </thead>
  );
};

export default UserTableHeader;
